import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import io from "socket.io-client";

import { chatMessage, roomLeave } from "../../../redux/actions/roomAction";
// import { tokenValidation } from "../redux/actions/userAction";

import ScrollDownToBottom from "react-scroll-to-bottom";
import ReactTooltip from "react-tooltip";

import "./chatRoom.css";

let socket;

const Chatbox = props => {
	// socket = props.trial;
	const dispatch = useDispatch();
	const history = useHistory();
	const userState = useSelector(state => state.user);
	const roomState = useSelector(state => state.room);

	const username = userState.username;
	const roomName = roomState.roomName;
	const messages = roomState.messages;
	const roomId = roomState._id;
	const clientUsername = username;

	const [message, setMessage] = useState("");
	const [chatlog, setChatlog] = useState([]);
	const [activeUsers, setActiveUsers] = useState([]);
	const ENDPOINT = window.location.origin;

	// const [send_BtnClick, setSend_BtnClick] = useState(false); // Indicates whether Public btn is clicked or not

	// ComponentMount
	useEffect(() => {
		// Making a connection to server using the url origin and joining a private/public room
		// console.log(props.trial);
		console.log("open");
		if (roomId) {
			socket = io.connect(ENDPOINT);
			socket.emit("join-chat", { username, roomName, messages });

			// Receive chat history if client is newly joined
			socket.on("serverInitialMessages", messages => {
				// console.log(messages);
				setChatlog(messages);
			});

			// Receive all message thrown by server (websocket)
			socket.on("serverMessage", ({ _id, username, message, date }) => {
				// console.log(chatlog, { _id, username, message, date })
				setChatlog(chatlog => [...chatlog, { _id, username, message, date }]);
			});

			// Receive the current active users thrown by server (websocket)
			socket.on("activeUsers", ({ users }) => setActiveUsers(users));
		} else history.push("/");
		return () => {
			if (roomId) {
				socket.disconnect();
				dispatch(roomLeave());
			}
		};
	}, [ENDPOINT]);

	// ComponentDidUpdate
	// useEffect(() => {}, []);

	// Sending message to server (websocket) and updating the database's chat history
	const handleSendMessage = e => {
		e.preventDefault();
		const date = new Date();
		socket.emit("clientSendMessage", {
			username,
			message,
			date,
		});
		dispatch(chatMessage(roomId, username, message, date));

		setMessage("");
	};

	function dateFormat(sentDate) {
		const currentDate = new Date();
		var messageDate = new Date(`${sentDate}`);

		const time = messageDate.toLocaleTimeString().replace(" ", ":").split(":");
		const date = messageDate.toDateString().split(" ");

		// Format: Sat 6:00pm
		// const day = `${date[0]} ${time[0]}:${time[1]}${time[3]}`;
		const day = `${date[0]} ${time[0]}:${time[1]}${time[3].toLowerCase()}`;
		// Format: Aug 29, 2020 at 6:00PM
		const week = `${date[1]} ${date[2]}, ${date[3]} at ${time[0]}:${time[1]}${time[3]}`;

		// To calculate the time difference of current date and message date
		const diffInTime = currentDate.getTime() - messageDate.getTime(); // milisecond

		// To calculate the no. of days between current date and message date
		const diffInDays = diffInTime / (1000 * 60 * 60 * 24); //  milisecond -> second -> minutes -> hours -> day

		// console.log(diffInDays < 7 ? day : week);
		// console.log("Difference_In_Days", diffInDays);
		return diffInDays < 7 ? day : week;
	}

	return (
		<div className="chatbox-page">
			<div className="chatbox">
				<div className="chatlog">
					<div className="chatlog-container">
						<ScrollDownToBottom>
							{/* {console.log("chatlog", chatlog)} */}
							<div className="chatlog-width">
								{chatlog.map(({ username, message, date }, index) => (
									<div
										key={index}
										className={clientUsername === username ? "chatlog-message-sent" : "chatlog-message-recieved"}
										data-tip={dateFormat(date)}
										data-for={clientUsername === username ? "left-message" : "right-message"}
									>
										{/* {console.log(date)} */}
										{clientUsername === username ? (
											<ReactTooltip id="left-message" effect="solid" place="left" />
										) : (
											<ReactTooltip id="right-message" effect="solid" place="right" />
										)}
										<div key={index}>{`${message}`}</div>
										<div style={{ textAlign: "right", fontSize: "7px" }}>{`${username}`}</div>
									</div>
								))}
							</div>
						</ScrollDownToBottom>
					</div>
				</div>

				<div className="chatForm">
					<div className="chatForm-container">
						<form
							onSubmit={e => {
								handleSendMessage(e);
								// setSend_BtnClick(true);
							}}
							className="input-group"
						>
							<input
								required
								type="text"
								name="message"
								id="message"
								placeholder="Write a message..."
								value={message}
								onChange={e => setMessage(e.target.value)}
								className="input-form"
							/>
							<button className="btn-form">Send</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Chatbox;
